import { Route } from '@/Enums/Routes/Route.enum';
import { NEW_ITEM_ID } from '@/constants/campaignManagement';
import { HTTP_STATUS_CODES } from '@/constants/httpStatusCodes';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NotFoundErrorContent = ({ campaignId }) => {
  return (
    <>
      <div className='font-bold text-[38px] text-center'>Campaign with id {campaignId} was not found</div>
      <div className='font-medium text-[20px] max-w-[480px] text-center'>Please verify it exists or</div>
      <Link to={`${Route.CAMPAIGN_MANAGEMENT}/${NEW_ITEM_ID}`}>
        <Button variant='contained' className='!mt-4'>
          Create New Campaign
        </Button>
      </Link>
    </>
  );
};

NotFoundErrorContent.propTypes = {
  campaignId: PropTypes.string.isRequired,
};

const ForbiddenErrorContent = () => {
  return <div className='font-bold text-[38px] text-center'>You don&apos;t have access to view this campaign</div>;
};

export default {
  [HTTP_STATUS_CODES.NOT_FOUND]: NotFoundErrorContent,
  [HTTP_STATUS_CODES.FORBIDDEN]: ForbiddenErrorContent,
};
